var map = {
	"./achievements.svg": "9da4",
	"./achievements_select.svg": "7a12",
	"./jackpots.svg": "880c",
	"./jackpots_select.svg": "0df0",
	"./scratch.svg": "11d5",
	"./scratch_select.svg": "63fa",
	"./sp_open.svg": "4d1b",
	"./tournaments.svg": "307f",
	"./tournaments_select.svg": "d8ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";